<template>
  <div>
    <button
      class="wc-focus flex size-12 items-center justify-center rounded-full"
      type="button"
      @click="menuOpen = true"
    >
      <span
        class="sr-only"
        v-text="'Open Navigation Menu'"
      />
      <IconMenu2
        :size="24"
        aria-hidden="true"
      />
    </button>
  </div>

  <TransitionRoot
    :show="menuOpen"
    as="template"
  >
    <Dialog
      :initial-focus="mobileMenuTitleRef"
      class="relative z-50 lg:hidden"
      @close="menuOpen = false"
    >
      <TransitionChild
        as="template"
        enter="ease-in-out duration-500 motion-reduce:transition-none"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-500 motion-reduce:transition-none"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10">
            <TransitionChild
              as="template"
              enter="transition-transform ease-out duration-300 motion-reduce:hover:transform-none"
              enter-from="-translate-x-full"
              enter-to="translate-x-0"
              leave="transition-transform ease-in duration-300 motion-reduce:hover:transform-none"
              leave-from="translate-x-0"
              leave-to="-translate-x-full"
            >
              <DialogPanel class="pointer-events-auto w-screen max-w-md">
                <DialogTitle
                  ref="mobileMenuTitleRef"
                  class="sr-only"
                  tabindex="-1"
                  v-text="'Site Navigation'"
                />
                <div class="flex h-full flex-col overflow-y-auto bg-white pb-6 shadow-sm">
                  <div class="flex justify-end">
                    <button
                      class="wc-focus relative flex size-12 items-center justify-center rounded-full focus-visible:outline-offset-1"
                      type="button"
                      @click="menuOpen = false"
                    >
                      <span class="absolute inset-px" />
                      <span
                        class="sr-only"
                        v-text="'Close Navigation Menu'"
                      />
                      <IconX
                        :size="24"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  <nav
                    aria-label="Primary"
                    class="relative flex-1"
                  >
                    <slot />
                  </nav>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts" setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { IconMenu2, IconX } from '@tabler/icons-vue'
import { ref } from 'vue'

defineOptions({
  name: 'AppMobileMenu',
})

const menuOpen = ref(false)
const mobileMenuTitleRef = ref<HTMLHeadingElement | null>(null)
</script>
